import { EgretLoadable } from "egret";
import ConstantList from "app/appConfig";
const AdministrativeIndex = EgretLoadable({
  loader: () => import("./HealthOganizationUnitIndex"),
});
const ViewComponent = AdministrativeIndex;
const AdministrativeDetailIndex = EgretLoadable({
  loader: () => import("./Details/HealthOganizationUnitDetail"),
});

const Routes = [
  {
    path: ConstantList.ROOT_PATH + "health-oganization-unit",
    exact: true,
    component: ViewComponent,
  },
  {
    path: ConstantList.ROOT_PATH + "health-oganization-unit/detail/:id",
    exact: true,
    component: AdministrativeDetailIndex,
  },
];

export default Routes;
